import React, { useState, useEffect } from 'react'
import { Recipient } from '../../../common/types/form'
import styled from 'styled-components'
import Scrollbars from 'react-scrollbars-custom'
import CustomSelect from '../../../common/components/SimpleInputs/CustomSelect/CustomSelect'
import { OptionType } from '../../../common/types/utilities'
import i18n from 'live/services/i18n'
import {
    getRecipientSelected,
    mapRecipientToOptionType,
    recipientToOptionsType
} from './helper/helperSelectRecipientGroup'

interface SelectRecipientGroupProps {
    options: Recipient[]
    selected: string[]
    onChange: (selectedList: string[]) => void
    editMode: boolean
    keepAllGroupsSelected?: boolean
    required?: boolean
    tooltip?: string
    tooltipMaxWidth?: string
    placeholder?: string
    title?:string
}

export default function SelectRecipientGroup({
    options,
    selected = [],
    onChange,
    editMode,
    keepAllGroupsSelected,
    required = true,
    tooltip = '',
    tooltipMaxWidth = '',
    title = '',
    placeholder = ''
}: SelectRecipientGroupProps) {
    const recipientsSelected = getRecipientSelected(selected, options)
    // TODO: FIX PLACEHOLDER CHANGING PLACE WHEN CLICKING THE SELECT
    return (
        <SelectRecipientGroupContainer recipientGroupsDisabled={!editMode}>
            <div className="selectRecipientGroupContainer">
                <div className="selectRecipientGroupContainer__select">
                    <CustomSelect
                        title={!!title ? title : i18n('Recipient Groups Selection')}
                        value={recipientsSelected.map(group => mapRecipientToOptionType(group))}
                        editMode={editMode}
                        required={required}
                        isMultiple={true}
                        isClearable={true}
                        options={recipientToOptionsType(options)}
                        closeMenuOnSelect={false}
                        showSelectedOnControl={false}
                        isSearchable={true}
                        onChange={(selectOptions: OptionType[], actionMeta) => {
                            switch (actionMeta.action) {
                                case 'clear':
                                    onChange([])
                                    break
                                case 'remove-value':
                                    onChange(selected.filter(uuid => uuid != actionMeta.removedValue.value))
                                    break
                                case 'select-option':
                                    const optionSelected = String(actionMeta?.option?.value)
                                    if (!selected.includes(optionSelected)) {
                                        onChange([...selected, optionSelected])
                                    }

                                    break
                                case 'deselect-option':
                                    onChange(selected.filter(uuid => uuid != actionMeta.option.value))
                                    break
                                //@ts-ignore
                                case 'set-value':
                                    onChange(options.map(({ uuid }) => uuid))
                                    break
                                case 'pop-value':
                                    break
                                case 'create-option':
                                    break
                                default:
                            }
                        }}
                        tooltip={!!tooltip ? tooltip : undefined}
                        tooltipMaxWidth={tooltipMaxWidth}
                        placeholder={!!placeholder ? placeholder : undefined}
                    />
                </div>

                <span className="selectRecipientGroupContainer__selectFooter">
                    <b>{`${keepAllGroupsSelected ? options.length : selected?.length}`} </b>
                    {i18n(`of`)} <b> {options?.length} </b>
                    {i18n(`selected`)}
                </span>

                <div
                    className={'SelectRecipientGroupContainer__listOfRecipients'}
                    style={{
                        height: '330px'
                    }}
                >
                    {!keepAllGroupsSelected && recipientsSelected.length == 0 ? (
                        <div
                            style={{
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column'
                            }}
                        >
                            <i
                                className={'far fa-empty-set'}
                                style={{
                                    color: '#BAC0CB',
                                    fontSize: '24px'
                                }}
                            />
                            <label
                                style={{
                                    fontStyle: 'normal'
                                }}
                            >
                                {i18n(`No Groups Selected`)}
                            </label>
                        </div>
                    ) : (
                        <Scrollbars
                            maximalThumbSize={90}
                            style={{
                                width: '100%',
                                height: '100%',
                                marginBottom: '2px'
                            }}
                        >
                            {(keepAllGroupsSelected ? options : recipientsSelected)?.map((recipient, index) => (
                                <div key={index} className={'SelectRecipientGroupContainer__listOfRecipients--item'}>
                                    <p className={'SelectRecipientGroupContainer__listOfRecipients--item__name'}>
                                        {recipient?.name}
                                    </p>
                                    <div className="SelectRecipientGroupContainer__listOfRecipients--item__action">
                                        <span
                                            className="SelectRecipientGroupContainer__listOfRecipients--item__action--delete far fa-times-circle"
                                            onClick={() => onChange(selected.filter(uuid => uuid !== recipient.uuid))}
                                        />
                                    </div>
                                </div>
                            ))}
                        </Scrollbars>
                    )}
                </div>
            </div>
        </SelectRecipientGroupContainer>
    )
}

const SelectRecipientGroupContainer = styled.div<{
    recipientGroupsDisabled: boolean
}>`
    .SelectRecipientGroupContainer {
        display: flex;
        felx-direction: column;

        &__listOfRecipients {
            display: flex;
            flex-direction: column;
            padding: 4px;
            border-radius: 3px;
            min-height: 200px;
            max-width: auto;
            background: ${props => (props.recipientGroupsDisabled ? props.theme['gray-100'] : props.theme['gray-0'])};
            margin-top: 14px;

            &--item {
                display: grid;
                grid-template-columns: 9fr 1fr;
                padding-top: 5px;
                padding-bottom: 5px;
                padding-left: 10px;
                margin-left: 10px;
                margin-right: 10px;
                border-bottom: 1px solid ${({ theme }) => theme['gray-300']};
                &__name {
                    color: ${props =>
                        props.recipientGroupsDisabled ? props.theme['gray-600'] : props.theme['gray-900']};
                    line-height: 16px;
                }
                &__action {
                    display: block;
                    text-align: center;
                    &--delete {
                        color: ${props =>
                            props.recipientGroupsDisabled ? props.theme['gray-500'] : props.theme['red-700']};
                        cursor: ${props => (props.recipientGroupsDisabled ? 'unset' : 'pointer')};
                        &:hover {
                            color: ${props =>
                                props.recipientGroupsDisabled ? props.theme['gray-500'] : props.theme['red-500']};
                        }
                        padding-top: 3px;
                    }
                }
            }
        }
    }
`
